import { render, staticRenderFns } from "./AltUniswapLineChart.vue?vue&type=template&id=609a2c4b&scoped=true&"
import script from "./AltUniswapLineChart.vue?vue&type=script&lang=js&"
export * from "./AltUniswapLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609a2c4b",
  null
  
)

export default component.exports